import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import ExportExcelByVpsComponent from "../../../../components/Customer/vps/ExportExcelByVpsComponent";

const PageExportExcelByVps = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ExportExcelByVpsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default PageExportExcelByVps;